import React from 'react';
import { MapPin, Ruler, Lightbulb, BarChart3 } from 'lucide-react';

const STEPS = [
  {
    id: 'step-1',
    number: '01',
    icon: MapPin,
    title: 'اختر نوع المكان',
    description: 'اختر نوع المكان من قائمة متنوعة تشمل المنازل والمكاتب والمحلات التجارية والمزيد.',
    color: 'text-primary',
    bg: 'bg-accent',
  },
  {
    id: 'step-2',
    number: '02',
    icon: Ruler,
    title: 'أدخل أبعاد المكان',
    description: 'أدخل الطول والعرض وارتفاع السقف وسيتم احتساب المساحة تلقائياً.',
    color: 'text-blue-500',
    bg: 'bg-blue-50',
  },
  {
    id: 'step-3',
    number: '03',
    icon: Lightbulb,
    title: 'اختر المصابيح',
    description: 'اختر نوع المصباح من القائمة أو أدخل بيانات مصباحك يدوياً بكل مرونة.',
    color: 'text-yellow-500',
    bg: 'bg-yellow-50',
  },
  {
    id: 'step-4',
    number: '04',
    icon: BarChart3,
    title: 'احصل على النتائج',
    description: 'احصل على تصميم الإضاءة الكامل مع مخطط التوزيع وتقرير مفصل قابل للطباعة.',
    color: 'text-green-500',
    bg: 'bg-green-50',
  },
];

export default function HowItWorks() {
  return (
    <section className="section-bg-light py-20" id="how-it-works">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">كيف يعمل؟</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mt-2 mb-4">
            أربع خطوات بسيطة للحصول على تصميم إضاءة احترافي
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            لا تحتاج خبرة هندسية مسبقة. الأداة تسألك أسئلة سهلة وتقوم بالحسابات المعقدة تلقائياً.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS?.map((step, index) => (
            <div key={step?.id} className="relative">
              {/* Connector line */}
              {index < STEPS?.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-0 w-full h-0.5 bg-border z-0"
                  style={{ width: 'calc(100% - 2.5rem)', right: '-50%', left: 'auto' }} />
              )}

              <div className="relative z-10 text-center">
                <div className={`w-20 h-20 ${step?.bg} rounded-2xl flex items-center justify-center mx-auto mb-4 relative`}>
                  <step.icon size={32} className={step?.color} />
                  <span className="absolute -top-2 -right-2 w-7 h-7 bg-primary text-white rounded-full text-xs font-bold flex items-center justify-center">
                    {index + 1}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-foreground mb-2">{step?.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{step?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}